import React from 'react';
import dayjs from 'dayjs';
import { Popconfirm } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faEye } from '@fortawesome/free-solid-svg-icons';

import styles from './DeviceListTable.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t, goToDeviceId) => [
  {
    width: '16%',
    title: t('tables.devices.columns.name'),
    dataIndex: 'name',
    render: (name) => name || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.client'),
    dataIndex: 'client',
    render: (client) => client || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.device_types'),
    render: (_, record) => record?.device_types_name || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.slvdl'),
    dataIndex: 'slvId',
    render: (slvId) => slvId || '-',
  },
  {
    width: '16%',
    title: t('tables.devices.columns.gateway'),
    render: (_, record) => record?.gateway?.name || '-',
  },
  {
    title: '',
    width: '3%',
    render: (_, record) => (
      // eslint-disable-next-line
      <div className={record?.device_twin?.connection_state !== 'Disconnected' ? ((record?.device_twin?.status && record?.device_twin?.status === 'Not Found') ? styles.stranger_device : styles.connected_device) : styles.disconnected_device}>
        <FontAwesomeIcon
          className={styles.faEye}
          icon={faEye}
          onClick={() => goToDeviceId(record)}
        />
      </div>
    ),
  },
];

const columnsDevices = (t, deleteDevice, editDevice, currentUser, goToDeviceId) => {

  const isAdmin = currentUser.role === 'Superadmin' || currentUser.role === 'Admin';

  const columns = commonColumns(t, goToDeviceId);

  if (isAdmin) {

    columns.push(
      {
        title: '',
        width: '3%',
        dataIndex: 'id',
        render: (_, record) => (
          // eslint-disable-next-line
          <div className={record?.device_twin?.connection_state !== 'Disconnected' ? ((record?.device_twin?.status && record?.device_twin?.status === 'Not Found') ? styles.stranger_device : styles.connected_device) : styles.disconnected_device}>

            <FontAwesomeIcon
              className={styles.faEye}
              icon={faEdit}
              onClick={() => editDevice(record)}
            />
          </div>
        ),
      },
      {
        title: '',
        width: '3%',
        dataIndex: 'id',
        render: (_, record) => (
          // eslint-disable-next-line
          <div className={record?.device_twin?.connection_state !== 'Disconnected' ? ((record?.device_twin?.status && record?.device_twin?.status === 'Not Found') ? styles.stranger_device : styles.connected_device) : styles.disconnected_device}>

            <Popconfirm
              title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
              okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
              cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
              onConfirm={() => deleteDevice(record)}
            >
              <FontAwesomeIcon
                icon={faTrash}
                className={styles.faEye}
              />
            </Popconfirm>
          </div>
        ),
      },

    );

}

  return columns;

};

export default columnsDevices;
